/**
 * Checks if the given event or key code matches the specified key properties.
 * @param {string|number} eventOrCode - The event or key code to match against.
 * @param {Object} [options=null] - The key properties to match against.
 * @param {string} [options.key] - The key value to match against.
 * @param {number} [options.which] - The "which" value to match against.
 * @param {number} [options.keyCode] - The key code value to match against.
 * @param {string} [options.code] - The code value to match against.
 * @returns {boolean} - True if the event or key code matches the specified key properties, false otherwise.
 */
function match(eventOrCode) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null,
    key = _ref.key,
    which = _ref.which,
    keyCode = _ref.keyCode,
    code = _ref.code;
  if (typeof eventOrCode === 'string') {
    return eventOrCode === key;
  }
  if (typeof eventOrCode === 'number') {
    return eventOrCode === which || eventOrCode === keyCode;
  }
  if (eventOrCode.key && Array.isArray(key)) {
    return key.indexOf(eventOrCode.key) !== -1;
  }
  return eventOrCode.key === key || eventOrCode.which === which || eventOrCode.keyCode === keyCode || eventOrCode.code === code;
}
function matches(event, keysToMatch) {
  for (var i = 0; i < keysToMatch.length; i += 1) {
    if (match(event, keysToMatch[i])) {
      return true;
    }
  }
  return false;
}

export { match, matches };
//# sourceMappingURL=match.js.map
